import {
  CheckCircleOutlined,
  StopOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import { Alert } from "antd";
import { useTranslation } from "react-i18next";
import Button from "shared/components/Button";
import { NAME_SPACES } from "shared/locales/constants";
import { PPE_ALERT_STATUS, PPE_ALERT_TYPE } from "utils/constants";
import { usePPEGEL } from "./PPEGELProvider";

const PPEGELActionButtons = ({ alert, personId }) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.PPEGEL);
  const ACTIONS = t("ACTIONS", { returnObjects: true });
  const { handleLever, handleConfirmer, handleAnnuler, isBlocked } =
    usePPEGEL();

  if (!alert) return null;

  const isGEL = alert.type === PPE_ALERT_TYPE.GELS_SANCTIONS;
  const isPending = alert.status === PPE_ALERT_STATUS.PENDING;
  const isRaised = alert.status === PPE_ALERT_STATUS.RAISED;
  const isConfirmed = alert.status === PPE_ALERT_STATUS.CONFIRMED;

  if (isPending && isBlocked) {
    return (
      <div className="ppegel-actions">
        <Alert type="info" showIcon message={ACTIONS.BLOCKED_INFO} />
      </div>
    );
  }

  if (isPending) {
    return (
      <div className="ppegel-actions ppegel-actions--buttons">
        <Button
          type="primary"
          className="ppegel-actions__btn ppegel-actions__btn--lever"
          onClick={() => handleLever(alert.id, personId)}
        >
          {ACTIONS.DISMISS}
        </Button>
        <Button
          type="primary--light"
          className="ppegel-actions__btn ppegel-actions__btn--confirmer"
          onClick={() => handleConfirmer(alert.id, personId)}
        >
          {ACTIONS.CONFIRM}
        </Button>
      </div>
    );
  }

  if (isRaised) {
    return (
      <div className="ppegel-actions">
        <Alert
          type="success"
          showIcon
          icon={<CheckCircleOutlined />}
          message={ACTIONS.DISMISSED_BANNER}
          className="ppegel-actions__banner ppegel-actions__banner--success"
          action={
            <Button
              type="primary--link"
              size="small"
              onClick={() => handleAnnuler(alert.id, personId)}
            >
              {ACTIONS.CANCEL}
            </Button>
          }
        />
      </div>
    );
  }

  if (isConfirmed && isGEL) {
    return (
      <div className="ppegel-actions">
        <Alert
          type="error"
          showIcon
          icon={<StopOutlined />}
          message={ACTIONS.BLOCKED_BANNER}
          className="ppegel-actions__banner ppegel-actions__banner--error"
          action={
            <Button
              type="primary--link"
              size="small"
              onClick={() => handleAnnuler(alert.id, personId)}
            >
              {ACTIONS.CANCEL}
            </Button>
          }
        />
      </div>
    );
  }

  if (isConfirmed && !isGEL) {
    return (
      <div className="ppegel-actions">
        <Alert
          type="warning"
          showIcon
          icon={<WarningOutlined />}
          message={ACTIONS.VIGILANCE_BANNER}
          className="ppegel-actions__banner ppegel-actions__banner--warning"
          action={
            <Button
              type="primary--link"
              size="small"
              onClick={() => handleAnnuler(alert.id, personId)}
            >
              {ACTIONS.CANCEL}
            </Button>
          }
        />
      </div>
    );
  }

  return null;
};

export default PPEGELActionButtons;
